// utilities
import './utilities/animations';
import './utilities/bg-hires-img';

// lightbox
require('fslightbox');

// components
import './components/main-navigation';
import './components/header';
import './components/hero';
import './components/accordion';
import './components/video';
import './components/slider';
import './components/tabs';
import './components/pop-up';

// import './components/video-carousel';
import './components/doctor-achievements';

// Before & After Gallery Slider
import './components/bna-gallery-slider';
import './components/bna-gallery-adult-check';